import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { EnterpriseService } from "../enterprise.service";
@Component({
  selector: "app-view-enterprise-details",
  templateUrl: "./view-enterprise-details.component.html",
  styleUrls: ["./view-enterprise-details.component.sass"],
})
export class ViewEnterpriseDetailsComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private enterpriseService: EnterpriseService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService
  ) {}
  id: "";
  enterpriseDetails: any;
  enterpriseDocuments: [];
  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.queryParams.id;
    this.getDetailsById();
  }

  getDetailsById() {
    this.spinner.show();
    this.enterpriseService
      .getEnterpriseRequestdetails(this.id)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.enterpriseDetails = result.data;
          this.spinner.hide();
          console.log("entp details", this.enterpriseDetails);
          if ([3, 4, 5].includes(this.enterpriseDetails.status)) {
            this.getDocumentsById();
          }
        } else {
          this.spinner.hide();
          this.toast.error(result.message);
        }
      });
  }
  getDocumentsById() {
    this.spinner.show();
    this.enterpriseService
      .getEnterpriseDocuments(this.id)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.enterpriseDocuments = result.data;
          this.spinner.hide();
          console.log("entp documents", this.enterpriseDetails);
        } else {
          this.spinner.hide();
          this.toast.error(result.message);
        }
      });
  }
  approveRejectEnterprise(status: Number) {
    this.spinner.show();
    const data = {
      status: status,
    };
    this.enterpriseService
      .updateRequest(this.id, data)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.toast.success(result.message);
          this.getDetailsById();
        } else {
          this.spinner.hide();
          this.toast.error(result.message);
        }
      });
  }

  goBack() {
    window.history.back();
  }
}
